import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { loadScript } from 'esri-loader'

// Preload Esri API scripts using esri-loader
loadScript({url: 'https://js.arcgis.com/3.34/'})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
